module.exports = __webpack_public_path__ + "img/study-h5.dc81a99b.png";